// extracted by mini-css-extract-plugin
export var social = "footer-module--social--kS8cm";
export var subfooter = "footer-module--subfooter--EsQhh";